import Hint from './Hint';

export default Hint;
export { toHintTone } from './toHintTone';
